import type { Row } from "@cd/core";

/**
 * Values of a grouping column to keep at full strength; the rest are dimmed. A widget grouped by a
 * field the page is filtered on shows the filter this way, so it doesn't collapse to one bar.
 */
export interface Highlight {
  key: string;
  values: Row[string][];
}

/** How strongly a dimmed mark is drawn. */
export const DIM_OPACITY = 0.25;

/**
 * Whether `v` is dimmed in column `key`: false when that column isn't highlighted. A missing value
 * (the "Other" a chart folds small values into) is never one of the highlighted values.
 */
export function isDimmed(highlight: readonly Highlight[] | undefined, key: string, v: Row[string] | undefined): boolean {
  const h = highlight?.find((x) => x.key === key);
  return !!h && (v === undefined || !h.values.some((x) => String(x) === String(v)));
}

/** Whether a result row is dimmed: any of its highlighted columns misses. */
export const isRowDimmed = (highlight: readonly Highlight[] | undefined, row: Row) =>
  !!highlight?.some((h) => isDimmed([h], h.key, row[h.key]));
